import axiosInstance from "../../axiosInstance";
import { PROCESS_QUEUE } from "../../routeNames";


// Process.js
export const getProcessQueueData = (params = {}) => async () => {
  try {
    const response = await axiosInstance.get(PROCESS_QUEUE, { params });

    const apiData = response?.data?.data?.results || [];

    const formattedData = apiData.map((item) => ({
      id: item.id,
      client: item.client,
      facility: item.facility,

      // 👇 keep all keys
      job: item.job || "",
      lockbox_name: item.lockbox_name || "",
      file_name: item.file_name || "",

      start_time: item.start_time,
      status: item.status,
    }));

    return {
      status: true,
      data: formattedData,
      count: response?.data?.data?.count || 0,
    };

  } catch (error) {
    console.log(error);
    return { status: false };
  }
};
